export const StitchDivider = ({ width = 120 }) => (
  <svg
    width={width}
    height="10"
    viewBox={`0 0 ${width} 10`}
    fill="none"
    aria-hidden="true"
    className="mx-auto"
  >
    <line
      x1="0"
      y1="5"
      x2={width}
      y2="5"
      stroke="var(--bronze)"
      strokeWidth="1"
      className="stitch-line"
      opacity="0.8"
    />
  </svg>
);

export default StitchDivider;
